var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFailureIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 297.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#c24462;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "failure-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_4",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 150.24,
    cy: 148.97,
    r: 149.76
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.54,81.52,146.73,122a5,5,0,0,0,7.06,0L194.2,82a5,5,0,0,1,7,0l16.57,16.23a5,5,0,0,1,0,7.12l-40.53,40.13a5,5,0,0,0,0,7.09l40.07,40a5,5,0,0,1,0,7.07L200.7,216.32a5,5,0,0,1-7.09,0l-39.83-40.17a5,5,0,0,0-7.09,0l-40.15,40.2a5,5,0,0,1-7.09,0L83.2,199.92a5,5,0,0,1,0-7.07l40.56-40.34a5,5,0,0,0,0-7.08L83.21,105a5,5,0,0,1,0-7.06l16.25-16.4A5,5,0,0,1,106.54,81.52Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailureIcon);
export default __webpack_public_path__ + "static/media/failure-icon.58e2cae048df987c56a6a8e83a3f29da.svg";
export { ForwardRef as ReactComponent };